<form [formGroup]="searchVideosForm">
    <div class="search-wrapper videosPartChannel" id="videos-search">
        <input placeholder="Search for videos..." formControlName="search"
               (keyup.enter)="searchVideos()">
        <i class="fas fa-search" (click)="searchVideos()"></i>
    </div>
</form>


